const ButtonScroll = () => {
  const button = document.querySelectorAll('.button-scroll');

  const findParentSection = currentNode => {
  	return currentNode ? currentNode.parentNode.closest('section') : false;
  }

  if (button.length) {
    button.forEach((item) => {

		item.addEventListener('click', _ => {
	    	let currentSection = findParentSection(item);
	    	let nextSection = currentSection.nextElementSibling;
	    	let i = 0;

	    	while (!nextSection && i < 4) {
	    		currentSection = findParentSection(currentSection);
	    		nextSection = currentSection ? currentSection.nextElementSibling : false;
	    		i++;
	    	}

	    	if (nextSection) {
				nextSection.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
	    	}
		});

    });
  }
};


export default ButtonScroll;
